export const CASHBOX_LIST = 'CASHBOX_LIST';
export const CASHWARRANT_STATUS = 'CASHWARRANT_STATUS';
export const CASHWARRANT_LIST_STOCK = 'CASHWARRANT_LIST_STOCK';
export const CASHWARRANT_LIST_ORG = 'CASHWARRANT_LIST_ORG';
